import React, { useEffect, useState } from 'react'
import API from '../../API';
import { Header, Pagination, Table } from 'react-frontier2';
import { Link } from 'react-router-dom';
import { ErrorHeader } from '../../components';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface EventZone { 
	event_id: number,
	event_name: string,
	promoter_name: string,
	venue_name: string,
	date: number,
}

function ZoneEvents(props: { zone_id: number }) {
	var { t } = useTranslation();
	var [events, setEvents] = useState<EventZone[]>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [page, setPage] = useState<number>(0);
	const PAGE_SIZE = 15;

	useEffect(()=>{
		if(props.zone_id && !isNaN(props.zone_id)) {
			loadData(page)
		}
	}, [props.zone_id])

	var loadData = (page?: number)=>{
		setEvents(null);
		API.getZoneEventsList(props.zone_id, page * PAGE_SIZE, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);
			setEvents(res.data);
		}).catch(err=>{
			setLoadError(t('common.unxpected_code', { code: 'LCL-ZNEVT-LD-1' }));
		})
	}

	var onPageChange = (page: number)=>{
		setPage(page);
		loadData(page)
	}

	if(loadError) return <ErrorHeader error={loadError} />
	if(!events) return <Header loading text={t('common.loading')} />

	var hasNext = events?.length >= PAGE_SIZE;
	return (
		<Table style={{ maxWidth: 700 }}>
			<Table.Head
				title='Eventos'
				data={[['ID', 'Evento', 'Promotor', 'Recinto', 'Siguiente Fecha']]}
				collapsingIndexes={[0, 4]}
			/>
			<Table.Body>
				{events.length===0 && (
					<Table.Cell empty row colSpan={100} value={'No hay eventos en esta zona'} />
				)}
				{events.map(e=>(
					<Table.Row compact selectable
						as={Link}
						key={`ZNEV-${e.event_id}`}
						to={`/events/${e.event_id}`}
						collapsingIndexes={[0, 4]}
						data={[
							e.event_id,
							e.event_name,
							e.promoter_name,
							e.venue_name,
							moment.unix(e.date).format('DD/MM/YY HH:mm:ss')
						]}
					/>
				))}
			</Table.Body>
			<Table.Footer actions={(
				<Pagination inline page={page} onPageChange={onPageChange} hasNext={hasNext} />
			)} />
		</Table>
	)
}

export default ZoneEvents;
